import React from "react";
import person1 from "../img/person1.jpg";
import person2 from "../img/person2.jpg";
import person3 from "../img/person3.jpg";
import "../css/home.css";

function Testimonial() {
  const testimonials = [
    {
      img: person1,
      name: "John Doe",
      text: "NeatNest made my house sparkle! Highly professional and reliable service.",
    },
    {
      img: person2,
      name: "Jane Smith",
      text: "I love their kitchen cleaning service. Everything is spotless and hygienic!",
    },
    {
      img: person3,
      name: "Michael Johnson",
      text: "Affordable and efficient. The team was friendly and did a fantastic job.",
    },
  ];

  return (
    <section className="testimonial-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h6 className="section-tag">TESTIMONIALS</h6>
             <hr className="center-hr " />
          <h2 className="section-title">What Our Customers Say</h2>
        </div>

        <div
          id="testimonialCarousel"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
          data-bs-interval="5000" // auto-slide every 5 seconds
        >
          <div className="carousel-inner">
            {testimonials.map((t, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                key={index}
              >
                <div className="testimonial-card text-center mx-auto p-4">
                  <img
                    src={t.img}
                    alt={t.name}
                    className="testimonial-img mb-3"
                  />
                  <p className="testimonial-text mb-2">{t.text}</p>
                  <h6 className="testimonial-name">{t.name}</h6>
                </div>
              </div>
            ))}
          </div>

          {/* Carousel controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#testimonialCarousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon rounded-circle bg-dark p-3"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#testimonialCarousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon rounded-circle bg-dark p-3"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>

          {/* Dots indicators */}
          <div className="carousel-indicators mt-4">
            {testimonials.map((_, index) => (
              <button
                type="button"
                key={index}
                data-bs-target="#testimonialCarousel"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : undefined}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
